import { render, staticRenderFns } from "./yampi.vue?vue&type=template&id=d8a9d6ec"
import script from "./yampi.vue?vue&type=script&lang=js"
export * from "./yampi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports